import { createFileRoute } from '@tanstack/react-router';
import { SsoCheck } from 'src/pages/sso';

export const Route = createFileRoute('/auth/sso')({
  component: () => <SsoCheck />,
});

export const useSsoRoutePageParams = Route.useParams;
